export default __webpack_public_path__ + "static/2180-1a39478faa4ce7d4cae790d870d61452.gif";